import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType } from "common/components/tooltip/types";
export function template() {
  const {
    disabled,
    editing,
    errorPlacement,
    inputValue,
    minInputWidth,
    placeholder,
    size,
    validationMessage,
    value
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-clickable-input-container", class: {
    "mp-clickable-input-editing": editing,
    ["mp-clickable-input-size-".concat(size)]: true
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("input", { attrs: this.helpers.getInputAttributes(), on: {
    input: this.helpers.handleInput,
    blur: this.helpers.handleInputBlur,
    keydown: this.helpers.handleKeydown,
    invalid: this.helpers.handleInputInvalid
  }, props: {
    value: inputValue
  }, style: {
    "min-width": editing ? minInputWidth : null
  }, hook: {
    insert: this.helpers.inputInsertHook
  } }), /* @__PURE__ */ jsx("div", { sel: ".mp-clickable-input-label", class: {
    "mp-clickable-input-disabled": disabled,
    "mp-clickable-input-empty": !value
  }, on: {
    click: disabled ? null : this.helpers.handleLabelClick
  } }, (editing ? inputValue : value) || placeholder), editing && validationMessage ? /* @__PURE__ */ jsx(TooltipEl, { sel: ".mp-clickable-input-error-message", attrs: {
    "always-show": true,
    placement: errorPlacement,
    type: DisplayType.Error
  } }, validationMessage) : null);
}
